function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import React, { Component } from 'react';
import { Manager, Popper, Reference } from 'react-popper';
import { CSSTransition } from 'react-transition-group';
import { TooltipArrow, TooltipContent, TooltipPopup, TooltipWrapper } from "./Tooltip.styles";
export var Tooltip =
/*#__PURE__*/
function (_Component) {
  _inherits(Tooltip, _Component);

  function Tooltip() {
    _classCallCheck(this, Tooltip);

    return _possibleConstructorReturn(this, _getPrototypeOf(Tooltip).apply(this, arguments));
  }

  _createClass(Tooltip, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          content = _this$props.content,
          children = _this$props.children,
          placement = _this$props.placement,
          positionFixed = _this$props.positionFixed;
      return React.createElement(TooltipWrapper, {
        className: className,
        timeout: 300
      }, function (_ref) {
        var mouseIn = _ref.mouseIn;
        return React.createElement(Manager, null, React.createElement(Reference, null, function (_ref2) {
          var ref = _ref2.ref;
          return children({
            ref: ref
          });
        }), React.createElement(CSSTransition, {
          in: mouseIn,
          timeout: 300,
          classNames: "infoPopup",
          unmountOnExit: true
        }, React.createElement(Popper, {
          placement: placement,
          modifiers: {
            keepTogether: {
              enabled: true
            },
            offset: {
              enabled: true,
              offset: '0, 10px'
            }
          },
          positionFixed: positionFixed
        }, function (_ref3) {
          var ref = _ref3.ref,
              style = _ref3.style,
              popupPlacement = _ref3.placement,
              arrowProps = _ref3.arrowProps;
          return React.createElement(TooltipPopup, {
            ref: ref,
            style: _objectSpread({}, style),
            "data-placement": placement
          }, React.createElement(TooltipContent, null, content), React.createElement(TooltipArrow, {
            arrowPlacement: popupPlacement === 'top' ? 'top' : 'bottom',
            ref: arrowProps.ref,
            style: arrowProps.style
          }));
        })));
      });
    }
  }]);

  return Tooltip;
}(Component);

_defineProperty(Tooltip, "defaultProps", {
  placement: 'top'
});